import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { subadminService } from '../services/SubadminServices';
import iconimg from "../assets/images/logo.png";

const Sidebar = () => {
  const [permissions, setPermissions] = useState(null);
  const [loading, setLoading] = useState(true);
  const id = localStorage.getItem('id');

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await subadminService.getSubadminPermission(id);
        setPermissions(response.data.permissions);
        setLoading(false);
      } catch (error) {
        console.error('Failed to fetch permissions:', error);
        setLoading(false);
      }
    };

    fetchPermissions();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!permissions) {
    return <div>No permissions available</div>;
  }

  return (
    <div className="sidebar py-2 py-md-2 me-0 border-end">
        <div className="d-flex flex-column h-100">
            <Link to="/admin/dashboard" className="mb-0 brand-icon">
                <span className="logo-icon">
                    <img src={iconimg} width={100}/>
                </span>
                <span className="logo-text">DCiWallet</span>
            </Link>
            <ul className="menu-list flex-grow-1 mt-4 px-1">
                {permissions.dashboard && (
                <li>
                    <Link className="m-link active" to="/admin/dashboard">
                        <div><h6 className="mb-0">Dashboard</h6><small className="text-muted">Analytics Report</small></div>
                    </Link>
                </li>
                )}
                {permissions.users && (
                <li>
                    <Link className="m-link" to="/admin/users">
                        <div><h6 className="mb-0">Users</h6><small className="text-muted">Users List</small></div>
                    </Link>
                </li>
                )}
                {permissions.plans && (
                <li>
                    <Link className="m-link" to="/admin/plans">
                        <div><h6 className="mb-0">Plans</h6><small className="text-muted">Plans List</small></div>
                    </Link>
                </li>
                )}
                {permissions.subadmins && (
                <li>
                    <Link className="m-link" to="/admin/subadmins">
                        <div><h6 className="mb-0">Subadmins</h6><small className="text-muted">Subadmin Users List</small></div>
                    </Link>
                </li>
                )}
                {permissions.wallets && (
                <li>
                    <Link className="m-link" to="/admin/wallets">
                        <div><h6 className="mb-0">Wallets</h6><small className="text-muted">Admin Wallet Addresses</small></div>
                    </Link>
                </li>
                )}
                {permissions.withdrawals && (
                <li>
                    <Link className="m-link" to="/admin/withdrawals">
                        <div><h6 className="mb-0">Withdrawals</h6><small className="text-muted">Withdrawal List</small></div>
                    </Link>
                </li>
                )}
                {permissions.support && (
                <li>
                    <Link className="m-link" to="/admin/support-tickets">
                        <div><h6 className="mb-0">Support</h6><small className="text-muted">Support Ticket List</small></div>
                    </Link>
                </li>
                )}
                {permissions.referrals && (
                <li>
                    <Link className="m-link" to="/admin/referrals-list">
                        <div><h6 className="mb-0">Referrals</h6><small className="text-muted">Referrals List</small></div>
                    </Link>
                </li>
                )}
                {permissions.transactions && (
                <li>
                    <Link className="m-link" to="/admin/transactions">
                        <div><h6 className="mb-0">Transactions</h6><small className="text-muted">Transactions List</small></div>
                    </Link>
                </li>
                )}
            </ul>
            <button type="button" className="btn btn-link sidebar-mini-btn text-muted">
                <span><i className="icofont-bubble-right"></i></span>
            </button>
        </div>
    </div>
  );
};

export default Sidebar;
